import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Index from './Index/index';
import HotWords from './HotWords';
import HotWordContent from './HotWordContent';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = (props) => {
    const { content } = props;

    const [ isMute, setIsMute ] = useState(true);
    const [ current, setCurrent ] = useState('A'); // 当前页，ABC
    const [ hotWordIndex, setHotWordIndex ] = useState(0); // 当前热词index

    const startPlay = () => {
        const audio = document.getElementById('audio');

        setIsMute(false);
        audio.play();
        document.removeEventListener('click', startPlay);
    };

    useEffect(() => {
        document.addEventListener('click', startPlay);

        return () => {
            document.removeEventListener('click', startPlay);
        };
    }, []);

    const handleCurrentChange = (type, index) => {
        setCurrent(type);
        if (index !== undefined) {
            setHotWordIndex(index);
        }
    };

    const GetContent = () => {
        switch (current) {
            case 'A': return <Index key="A" onChange={handleCurrentChange} />;
            case 'B': return <HotWords key="B" content={content} onChange={handleCurrentChange} />;
            case 'C': return <HotWordContent key="C" content={content} index={hotWordIndex} />;
            default: return null;
        }
    };

    const toggleIsMute = () => setIsMute(!isMute);

    const back = () => {
        switch (current) {
            case 'A': return;
            case 'B': setCurrent('A'); break;
            case 'C': setCurrent('B');
        }
    };

    return (
        <div className={styles.layout}>
            <div className={styles.toolbar}>
                <div className={`${styles.back} ${current === 'A' ? styles.disable : ''}`} onClick={back}>
                    <img src={require('../asset/arrowLeft.png')} alt="" />
                </div>
                <div className={styles.audio}>
                    <img onClick={toggleIsMute} src={ isMute ? 'https://x0.ifengimg.com/ucms/2020_21/C46DE9AE8F0B6DACA3209183C43134713869A4C6_w42_h47.png' : 'https://x0.ifengimg.com/ucms/2020_21/DDF6EED38CF7F7F08DAD8958528C49F20D74F2F1_w40_h44.png'} alt="" />
                    <audio id="audio" src="https://x0.ifengimg.com/fe/custom/2022_03_05/govReport2022.mp3" muted={isMute} preload="auto" loop={true} autoPlay={true} />
                </div>
            </div>
            {
                GetContent()
            }
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
